module.exports = __webpack_public_path__ + "static/service-2eed121d60162da671a41d8e1390d10f.jpeg";